import React, { useContext, useEffect } from "react";
import styled from "styled-components";
import GallerySection from "./GallerySection";
import HeroSection from "./HeroSection";
import MetaPoolSection from "./MetaPoolSection";
import SocialMediaInfoSection from "./SocialMediaInfoSection";
import NftArrivals from "../NftMarket/NftMarketPage/NftArrivals";

import environmentVariables from "../../config/environmentVariables";
import { userBalanceContext } from "../../context/userBalanceContext";
import axios from "axios";
import { userInfoContext } from "../../context/userInfoContext";

const Root = styled.div``;
const Container = styled.div`
  width: 80%;
  margin: 0 auto;
  padding-bottom: 50px;
  @media (max-width: ${(p) => p.theme.screen.lg}) {
    width: 90%;
  }
  @media (max-width: ${(p) => p.theme.screen.md}) {
    width: calc(100% - 40px);
  }
`;
const Home = (props) => {
  const { setUserBalance } = useContext(userBalanceContext);

  const {userAccInfo, setUserAccInfo}=useContext(userInfoContext)

  const getUserBalance = (address) => {
    axios
      .get(
        `${environmentVariables?.apiUrl}/nftmarketplace/api/v1/getuserbalance/${address}`,
        {headers:{
          authorization:`Bearer ${userAccInfo}`
        }}
      )
      .then((res) => {
        // console.log(res.data.data);
        setUserBalance(res.data.data);
      })
      .catch((err) => console.log(err));
  };
  useEffect(() => {
    if (props?.allContractDetails) {
      getUserBalance(props?.allContractDetails?.address);
    }
  }, [props?.allContractDetails]);
  return (
    <Root>
      <HeroSection {...props} />
      <SocialMediaInfoSection />
      <GallerySection />
      <MetaPoolSection />
      <Container>
        <NftArrivals isHome={true} {...props} />
        {/* <ActiveUpcomingNft {...props} /> */}
      </Container>
    </Root>
  );
};

export default Home;
